import React from "react";
import { ComposedChart, BarChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { fmtPct, fmtUsd, pColor, periodLabel } from "./marginUtil";

const axis = { tick: { fontSize: 10, fill: "#94A3B8" } };
const usdTick = (v) => (v === 0 ? "$0" : Math.abs(v) >= 1 ? `$${v.toFixed(0)}` : `$${v.toFixed(Math.abs(v) >= 0.01 ? 2 : 4)}`);

function Tip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl border border-line bg-white p-3 text-xs shadow-lg">
      <p className="mb-1 font-bold text-slate-900">{label}</p>
      {payload.filter((p) => p.value != null).map((p) => <p key={p.dataKey} className="flex items-center gap-2 text-slate-600"><span className="h-2 w-2 rounded-full" style={{ background: p.color }} />{p.name}: <b className="font-mono">{p.dataKey === "markup_pct" ? fmtPct(p.value) : fmtUsd(p.value)}</b></p>)}
    </div>
  );
}

export function CostRevenueChart({ data }) {
  const pts = data.map((d) => ({ ...d, label: periodLabel(d.period) }));
  return (
    <div className="h-72" data-testid="margin-chart-main">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={pts} margin={{ left: 0, right: 0, top: 4 }}>
          <CartesianGrid stroke="#E2E8F0" vertical={false} />
          <XAxis dataKey="label" minTickGap={16} {...axis} />
          <YAxis yAxisId="usd" tickFormatter={usdTick} width={56} {...axis} />
          <YAxis yAxisId="pct" orientation="right" tickFormatter={(v) => `${v}%`} width={44} {...axis} />
          <Tooltip content={<Tip />} cursor={{ fill: "rgba(37,99,235,.05)" }} /><Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar yAxisId="usd" dataKey="net_revenue_usd" name="Pendapatan bersih" fill="#2563EB" radius={[4, 4, 0, 0]} isAnimationActive={false} />
          <Bar yAxisId="usd" dataKey="cost_usd" name="Biaya AI" fill="#A855F7" radius={[4, 4, 0, 0]} isAnimationActive={false} />
          <Line yAxisId="pct" dataKey="markup_pct" name="Markup %" stroke="#06B6D4" strokeWidth={2} dot={{ r: 2 }} connectNulls={false} isAnimationActive={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}

export function ProviderStackChart({ data, providers }) {
  const pts = data.map((d) => ({ ...d, label: periodLabel(d.period) }));
  return (
    <div className="h-64" data-testid="margin-chart-providers">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={pts} margin={{ left: 0, right: 8, top: 4 }}>
          <CartesianGrid stroke="#E2E8F0" vertical={false} />
          <XAxis dataKey="label" minTickGap={16} {...axis} /><YAxis tickFormatter={usdTick} width={56} {...axis} />
          <Tooltip content={<Tip />} cursor={{ fill: "rgba(37,99,235,.05)" }} /><Legend wrapperStyle={{ fontSize: 11 }} />
          {providers.map((p, i) => <Bar key={p.provider} dataKey={`p_${p.provider}`} name={p.provider_label} stackId="c" fill={pColor(p.provider, i)} isAnimationActive={false} />)}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
